module.exports = __webpack_public_path__ + "media/staff/jenny-1e907b21.png";